import { TextField, Select, MenuItem, IconButton, FormControl, Autocomplete, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

const emojiOptions = [
  '🥬', '🥗', '🌿', '🌱', '🍃', '🥒', '🍅', '🥕',
  '🥔', '🥦', '🎃', '🫘', '🫛', '🫑', '🧅', '🎁', '👶',
];

const itemTypeOptions = [
  { value: 'REGULAR', label: 'Thường' },
  { value: 'COMBO', label: 'Combo/Set' },
  { value: 'BABY_FOOD', label: 'Ăn dặm bé' },
  { value: 'FREE_GIFT', label: 'Tặng kèm' },
];

const itemTypeBorderColors = {
  'REGULAR': 'transparent',
  'COMBO': '#9c27b0',
  'BABY_FOOD': '#2196f3',
  'FREE_GIFT': '#ffa726',
};

const itemTypeBgColors = {
  'REGULAR': 'transparent',
  'COMBO': '#f3e5f5',
  'BABY_FOOD': '#e3f2fd',
  'FREE_GIFT': '#fff8e1',
};

const MenuItemRow = ({ item, onChange, onRemove, products = [], disabled = false }) => {
  const handleChange = (field, value) => {
    onChange({ ...item, [field]: value });
  };

  const handleProductSelect = (_, product) => {
    if (product) {
      onChange({
        ...item,
        product_id: product.id,
        name: product.name,
        convert_rate: product.convert_rate || 1,
        item_type: product.is_combo ? 'COMBO' : 'REGULAR',
      });
    } else {
      onChange({ ...item, product_id: null });
    }
  };

  const handleQuantityChange = (qty) => {
    const rate = item.convert_rate || 1;
    const converted = qty ? Math.round((qty / rate) * 100) / 100 : null;
    onChange({
      ...item,
      quantity: qty,
      weight_value: converted,
      weight_text: converted ? `${converted}kg` : '',
    });
  };

  const convertedQty = (item.quantity && item.convert_rate)
    ? Math.round((item.quantity / item.convert_rate) * 100) / 100
    : item.weight_value || 0;

  const selectedProduct = item.product_id
    ? products.find(p => p.id === item.product_id) || null
    : null;

  return (
    <div style={{
      padding: '6px 8px',
      borderLeft: `3px solid ${itemTypeBorderColors[item.item_type] || 'transparent'}`,
      borderRadius: '4px',
      backgroundColor: itemTypeBgColors[item.item_type] || 'transparent',
    }}>
      {/* Row 1: emoji, product name, item type, delete */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <FormControl size="small" sx={{ width: 60 }}>
          <Select
            value={item.emoji || ''}
            onChange={(e) => handleChange('emoji', e.target.value)}
            displayEmpty
            disabled={disabled}
            renderValue={(val) => <span style={{ fontSize: '1.1rem' }}>{val || '🥬'}</span>}
            sx={{ '& .MuiSelect-select': { textAlign: 'center', py: '6px' } }}
          >
            {emojiOptions.map((e) => (
              <MenuItem key={e} value={e} sx={{ fontSize: '1.3rem', justifyContent: 'center' }}>{e}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <Autocomplete
          size="small"
          options={products}
          getOptionLabel={(opt) => opt.name || ''}
          value={selectedProduct}
          onChange={handleProductSelect}
          freeSolo
          disabled={disabled}
          onInputChange={(_, value, reason) => {
            if (reason === 'input') {
              handleChange('name', value);
            }
          }}
          inputValue={item.name || ''}
          renderInput={(params) => (
            <TextField {...params} placeholder="Tìm sản phẩm" required />
          )}
          isOptionEqualToValue={(opt, val) => opt.id === val?.id}
          sx={{ flex: 1, minWidth: 120 }}
        />
        <FormControl size="small" sx={{ minWidth: 110 }}>
          <Select
            value={item.item_type || 'REGULAR'}
            onChange={(e) => handleChange('item_type', e.target.value)}
            disabled={disabled}
          >
            {itemTypeOptions.map(opt => (
              <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
            ))}
          </Select>
        </FormControl>
        {!disabled && (
          <IconButton size="small" onClick={onRemove} color="error">
            <DeleteIcon fontSize="small" />
          </IconButton>
        )}
      </div>
      {/* Row 2: detail, quantity, converted weight */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '4px', paddingLeft: 68 }}>
        <TextField
          size="small"
          value={item.detail || ''}
          onChange={(e) => handleChange('detail', e.target.value)}
          placeholder="Chi tiết"
          disabled={disabled}
          sx={{ flex: 1 }}
        />
        <TextField
          size="small"
          type="number"
          value={item.quantity ?? ''}
          onChange={(e) => handleQuantityChange(e.target.value ? parseFloat(e.target.value) : null)}
          placeholder="Số lượng"
          disabled={disabled}
          sx={{ width: 120 }}
          inputProps={{ step: 0.05, min: 0 }}
        />
        <Typography sx={{ minWidth: 60, textAlign: 'center', fontSize: '0.85rem', fontWeight: 600, color: '#2d7a3f', whiteSpace: 'nowrap' }}>
          {convertedQty ? `${convertedQty}kg` : '-'}
        </Typography>
      </div>
    </div>
  );
};

export default MenuItemRow;
